import { Text } from "@chakra-ui/react";

export const SalesCannotEditCanceledSaleError = () => {
  return <Text>Cette vente a déjà été annulée.</Text>;
};
